import produce from 'immer';
import {
    STORE_LIMIT,
    SELECT_GRID,
    SELECT_LIMIT,
    UPDATE_PRODUCTS_COUNT,
    SET_PAGINATION,
    SET_QUERY,
    SET_PRODUCTS,
    SET_OVERLAY,
    SET_SORT_ORDER,
    SET_SORTING,
    ADD_FILTER,
    REMOVE_FILTER,
    CLEAR_FILTER,
    SET_CURRENT_PAGE,
    SET_SELECTED_FILTERS,
    SET_PRICE_RANGE,
    SET_SEO_DATA,
    SET_MODEL_IMAGE_MODE
} from '../actions/actionTypes';

const initialState = {
    navigationId: null,
    gridView: null,
    gridViewFromConfig: null,
    gridOptions: [],
    limit: {},
    productsCount: 0,
    pagination: {
        currentPage: 1,
        totalListingPagesCount: 1
    },
    selectedFilters: {},
    query: {},
    products: [],
    pageInfo: {},
    overlayActive: false,
    gender: null,
    sorting: {},
    availableFilters: [],
    gridImageSizes: [],
    trackingName: '',
    inlistingBanners: null,
    productsGroup: '',
    seoData: null
};

const Listing = produce((state, action) => {
    const { type, payload } = action;

    switch (type) {
        case STORE_LIMIT: {
            state.limit = payload;
            break;
        }

        case SELECT_GRID: {
            const hasGridFromConfig = state.gridViewFromConfig != null;

            if (hasGridFromConfig) {
                state.gridViewFromConfig = payload;
            } else {
                state.gridView = payload;
            }

            break;
        }

        case SELECT_LIMIT: {
            const limitPayload = Number(payload);

            state.limit = Object.keys(state.limit).reduce((acc, limitItem) => {
                acc[limitItem] = Number(limitItem) === limitPayload;
                return acc;
            }, {});

            state.query.limit = limitPayload;
            break;
        }

        case UPDATE_PRODUCTS_COUNT: {
            state.productsCount = payload;
            break;
        }

        case SET_PAGINATION: {
            state.pagination = payload;
            break;
        }

        case SET_QUERY: {
            state.query = payload;
            break;
        }

        case SET_PRODUCTS: {
            state.products = payload;
            break;
        }

        case SET_OVERLAY: {
            state.overlayActive = payload;
            break;
        }

        case SET_SORT_ORDER: {
            if (!payload) {
                delete state.query.order;
                break;
            }

            state.query.order = payload;
            break;
        }

        case SET_SORTING: {
            state.sorting = payload;
            break;
        }

        case ADD_FILTER: {
            const { filterId, filterType, filterItem } = payload;

            if (typeof state.query[filterType] === 'undefined') {
                state.query[filterType] = [];
            }

            if (typeof state.selectedFilters[filterId] === 'undefined') {
                state.selectedFilters[filterId] = [];
            }

            if (!Array.isArray(state.query[filterType])) {
                state.query[filterType] = state.query[filterType].split(',');
            }

            state.query[filterType].push(filterItem.id);
            state.selectedFilters[filterId].push(filterItem);

            break;
        }

        case REMOVE_FILTER: {
            const { filterId, filterType, filterItem } = payload;
            state.selectedFilters[filterId] = state.selectedFilters[filterId].filter(item => item.id !== filterItem.id);

            if (!Array.isArray(state.query[filterType])) {
                state.query[filterType] = state.query[filterType].split(',');
            }

            state.query[filterType] = state.query[filterType].filter(item => item !== filterItem.id);

            if (!state.query[filterType].length) {
                delete state.query[filterType];
            }

            break;
        }

        case CLEAR_FILTER: {
            const { filterId, filterType } = payload;

            delete state.query[filterType];
            state.selectedFilters[filterId] = [];

            break;
        }

        case SET_SELECTED_FILTERS: {
            const selectedFilterOptions = payload.reduce((newFiltersArray, item) => {
                let valueToSet;

                switch (true) {
                    case !item.groups.length: {
                        valueToSet = [];
                        break;
                    }

                    case item.id === 'pricerange': {
                        valueToSet = item.groups[0].selectedOptions;
                        break;
                    }

                    default: {
                        const flatten = item.groups.map(groupItem => groupItem.selectedOptions);
                        valueToSet = flatten.reduce((acc, curr) => { acc.push(...curr); return acc; }, []);
                    }
                }

                newFiltersArray.push({ [item.id]: valueToSet });
                return newFiltersArray;
            }, []);

            state.selectedFilters = Object.assign({}, ...selectedFilterOptions);

            state.availableFilters = payload;
            break;
        }

        case SET_PRICE_RANGE: {
            const { min, max } = payload;
            state.query.pricerange = `${min}-${max}`;
            state.selectedFilters.pricerange = { min, max };
            break;
        }

        case SET_CURRENT_PAGE: {
            state.pagination.currentPage = payload;
            state.query.page = payload;
            break;
        }

        case SET_SEO_DATA: {
            state.seoData = payload;
            break;
        }

        case SET_MODEL_IMAGE_MODE: {
            state.modelImageMode = payload;
            break;
        }

        // skip default
    }
}, initialState);

export default Listing;
